var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "16px",
    viewBox: "0 0 21 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "uk") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDDA5\\uFE0F-Baby-Odin-Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "User-Dropdown-Copy-2",
    transform: "translate(-33.000000, -149.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uk",
    transform: "translate(33.000000, 149.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.125,0 L0.875,0 C0.391750844,0 0,0.397969111 0,0.888888889 L0,15.1111111 C0,15.6020309 0.391750844,16 0.875,16 L20.125,16 C20.6082492,16 21,15.6020309 21,15.1111111 L21,0.888888889 C21,0.397969111 20.6082492,0 20.125,0 Z",
    id: "Path",
    fill: "#002781"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,0.888888889 C21,0.397969111 20.6082492,0 20.125,0 L17.8670625,0 L12.25,4.38933333 L12.25,0 L8.75,0 L8.75,4.38933333 L3.1329375,0 L0.875,0 C0.391750844,0 0,0.397969111 0,0.888888889 L0,2.03822222 L5.3545625,6.22222222 L0,6.22222222 L0,9.77777778 L5.3545625,9.77777778 L0,13.9622222 L0,15.1111111 C0,15.6020309 0.391750844,16 0.875,16 L3.1329375,16 L8.75,11.6106667 L8.75,16 L12.25,16 L12.25,11.6106667 L17.8670625,16 L20.125,16 C20.6082492,16 21,15.6020309 21,15.1111111 L21,13.9622222 L15.6454375,9.77777778 L21,9.77777778 L21,6.22222222 L15.6454375,6.22222222 L21,2.03822222 L21,0.888888889 Z",
    id: "Path",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D10D24",
    points: "11.375 7.11111111 11.375 0 9.625 0 9.625 7.11111111 0 7.11111111 0 8.88888889 9.625 8.88888889 9.625 16 11.375 16 11.375 8.88888889 21 8.88888889 21 7.11111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,10 L1,15.9810885 C1.05969121,15.9933929 1.12053126,15.99973 1.18156152,16 L2.21793897,16 L9,10.9296071 L9,10 Z",
    id: "Path",
    fill: "#D10D24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,6 L21,0.018911536 C20.9403054,0.00662755606 20.8794675,0.000290654263 20.8184385,0 L19.782061,0 L13,5.0708132 L13,6 Z",
    id: "Path",
    fill: "#D10D24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,6 L0.273242253,0 C0.0987401275,0.16754456 0,0.399522618 0,0.64205983 L0,0.776008335 L6.72842386,6 L8,6 Z",
    id: "Path",
    fill: "#D10D24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,10 L20.7267577,16 C20.9012599,15.8324554 21,15.6004774 21,15.3579402 L21,15.2239917 L14.2715761,10 L13,10 Z",
    id: "Path",
    fill: "#D10D24"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUk);
export default __webpack_public_path__ + "static/media/uk.c6c20daf.svg";
export { ForwardRef as ReactComponent };